import { Box, CircularProgress } from "@mui/material";

export const SimpleBoxLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "40vh",
      width: "100%",
    }}
  >
    <CircularProgress />
  </Box>
);
